import { Grid, SxProps, Theme, Typography, Box } from "@mui/material";
import {
  Error as ErrorIcon,
  Warning as WarningIcon,
  Info as InfoIcon,
  Schedule as ScheduleIcon,
} from "@mui/icons-material";
import { SectionContainer } from "src/modules/SectionContainer/SectionContainer";
import { SectionTitle } from "src/modules/SectionTitle/SectionTitle";
import { SectionSubtitle } from "src/modules/SectionSubtitle/SectionSubtitle";
import { Card } from "../../modules";

export const Sla = () => {
  return (
    <SectionContainer sx={{ background: "white" }}>
      <SectionTitle>サービスレベル保証（SLA）</SectionTitle>
      <SectionSubtitle>明確なサービスレベル目標で、お客様のシステム安定稼働を保証</SectionSubtitle>

      <Grid container spacing={4}>
        <Grid item xs={12}>
          <Typography variant="h5" sx={sectionTitleSx}>
            対応レベル保証
          </Typography>
          <Grid container spacing={3}>
            <Grid item xs={12} md={4}>
              <Card variant="light" sx={cardSx}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <ErrorIcon sx={{ color: "#d32f2f", fontSize: "1.5rem" }} />
                  <Card.Title>緊急対応（P1）</Card.Title>
                </div>
                <Typography variant="body2" sx={cardDescriptionSx}>
                  システム停止や重大な障害に対する最優先対応
                  <br />
                  即座の対応開始と迅速な解決を保証
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card variant="light" sx={cardSx}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <WarningIcon sx={{ color: "#ed6c02", fontSize: "1.5rem" }} />
                  <Card.Title>重要対応（P2）</Card.Title>
                </div>
                <Typography variant="body2" sx={cardDescriptionSx}>
                  業務に影響する問題に対する優先対応
                  <br />
                  適切なタイミングでの対応開始と解決を保証
                </Typography>
              </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Card variant="light" sx={cardSx}>
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                  <InfoIcon sx={{ color: "#1976d2", fontSize: "1.5rem" }} />
                  <Card.Title>通常対応（P3）</Card.Title>
                </div>
                <Typography variant="body2" sx={cardDescriptionSx}>
                  一般的な問い合わせや軽微な問題に対する対応
                  <br />
                  計画的かつ確実な解決を保証
                </Typography>
              </Card>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Box sx={bannerSx}>
            <Typography sx={bannerTitleSx}>
              <ScheduleIcon />
              24時間365日対応
            </Typography>
            <Typography variant="body1" sx={bannerDescriptionSx}>
              休日・深夜も含む継続的なサポート体制
              <br />
              お客様の業務時間に関係なく対応可能
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </SectionContainer>
  );
};

const sectionTitleSx: SxProps<Theme> = {
  fontSize: "1.3rem",
  marginBottom: "20px",
  color: "#1a1a2e",
  fontWeight: 600,
};

const cardSx: SxProps<Theme> = {
  height: "100%",
};

const cardDescriptionSx: SxProps<Theme> = {
  color: "#666",
  fontSize: "0.9rem",
  lineHeight: 1.6,
  marginTop: "10px",
};

const bannerSx: SxProps<Theme> = {
  background: "linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)",
  borderRadius: "12px",
  padding: "24px",
  textAlign: "center",
  boxShadow: "0 4px 12px rgba(33, 150, 243, 0.15)",
};

const bannerTitleSx: SxProps<Theme> = {
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
  color: "#1565c0",
  fontWeight: 700,
  fontSize: "1.2rem",
};

const bannerDescriptionSx: SxProps<Theme> = {
  color: "#1976d2",
  fontSize: "1rem",
  lineHeight: 1.6,
  marginTop: "12px",
  fontWeight: 500,
};
